export default defineNuxtRouteMiddleware(async (to) => {
    // Только для маршрутов /ch/[id]
    if (!to.path.startsWith('/ch/')) {
        return;
    }

    try {
        const PlaceService = await import('~/services/PlaceService');
        const paramId = to.params.id as string;
        // Бек всегда создаёт slug для канала, поэтому ищем только по slug.
        // Запрос по ID запрещён: для числового slug бек может вернуть данные совершенно другого канала.
        const result = await PlaceService.default.getPlace(undefined, paramId);

        // Сохраняем результат в nuxtApp для использования в компоненте
        const nuxtApp = useNuxtApp();
        nuxtApp.payload.channelData = result;

    } catch (error: any) {
        if (error.response?.status === 404) {
            throw createError({
                statusCode: 404,
                statusMessage: 'Канал не найден'
            });
        }
        // Для 400 и других ошибок тоже показываем 404
        if (error.response?.status === 400) {
            throw createError({
                statusCode: 404,
                statusMessage: 'Канал не найден'
            });
        }
        throw error;
    }
});
